import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "You are about to delete enrolled contacts!", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6" }, " By deleting these contacts you will lose all communication history and will not be able to recover these contacts in the future. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6" }, "Are you sure you would like to delete these contacts?", -1)
const _hoisted_4 = { class: "rounded-md bg-yellow-50 p-4 mt-6" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "flex-shrink-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-sm font-medium text-yellow-800" }, " The contacts will be permanently deleted from your account ")
], -1)

import { ExclamationIcon } from "@heroicons/vue/solid"

export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteContactsComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(ExclamationIcon), {
            class: "h-5 w-5 text-yellow-400",
            "aria-hidden": "true"
          })
        ]),
        _hoisted_7
      ])
    ])
  ], 64))
}
}

})